import { groupLifeProposalsService } from '@/services/proposals/group-life';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useInitiateGroupLifeProposal() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['group-life-proposal', 'initiate'],
    mutationFn: async (policyId: string) => {
      const result = await groupLifeProposalsService.initiateProposal(policyId);
      if (!result.success) {
        throw new Error(result.error ?? 'Erro ao iniciar a proposta');
      }
      return { policyId, data: result.data };
    },
    onSuccess: async (_, policyId) => {
      await queryClient.invalidateQueries({ queryKey: ['proposals'] });
      await queryClient.invalidateQueries({
        queryKey: ['group-life-proposal', policyId],
      });
    },
  });
}
